import { createContext, useContext } from "react";
import { AuthService, useAuthService } from "./authservice";
import { Constants } from "./constants";

export default class ApiService {
    private apiUrl: string;
    private authService: AuthService;

    constructor(apiUrl: string, authService: AuthService) {
        this.apiUrl = apiUrl;
        this.authService = authService;
    }

    async post(uri: string, payload: any) {
        return fetch(this.apiUrl + uri, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.authService.getAuthToken()}`,
            },
        }).catch(function (error) {
            /*logout logic*/
            console.error('Logout', error);
            throw error;
        });
    }

    async get(uri: string) {
        return fetch(this.apiUrl + uri, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.authService.getAuthToken()}`,
            },
        }).catch(function (error) {
            /*logout logic*/
            console.error('Logout', error);
            throw error;
        });
    }

    async delete(uri: string) {
        return fetch(this.apiUrl + uri, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.authService.getAuthToken()}`,
            },
        }).catch(function (error) {
            /*logout logic*/
            console.error(error);
            throw error;
        });
    }
}

export function useApiService() {
    const authService = useAuthService();
    return new ApiService(Constants.API_URL, authService);
}